const storyCategories = require("./storyCategories");

function storyCategory(chars = 0, words = 0) {
  const categories = storyCategories(words);

  for (let { match, minChar, maxChar, min, max, name } of categories) {
    let testMatch = match ? match === words : true;

    let testMinChar = minChar ? chars >= minChar : true;

    let testMaxChar = maxChar ? chars <= maxChar : true;

    let testMin = min ? words >= min : true;

    let testMax = max ? words <= max : true;

    if (testMatch && testMinChar && testMaxChar && testMin && testMax)
      return name;
  }
}

module.exports = storyCategory;
